import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AboutBanner = () => {
	const [src, setSrc] = useState('/images/ab-banner.png');
	const FALLBACK_IMAGE = '/images/ab-banner.png';

	return (
		<section className="relative overflow-hidden bg-white min-h-screen">
			{/* Top Banner Section with Colorful Abstract Background */}
			<div className="relative min-h-screen overflow-hidden">
				{/* Abstract Colorful Background with Horizontal Streaks */}
				<div className="absolute inset-0 h-[90vh] sm:h-[92vh] md:h-[94vh] lg:h-[95vh]">
					{/* Blue to Purple Streaks */}
					<motion.img
                src={src}
                onError={() => setSrc(FALLBACK_IMAGE)}
                alt="Color waves"
                className="absolute inset-0 w-full h-full object-cover select-none pointer-events-none"
                style={{ objectPosition: 'center 50%' }}
                initial={{ scale: 1.04 }}
                animate={{ scale: [1.04, 1.05, 1.04] }}
                transition={{ repeat: Infinity, duration: 24, ease: 'easeInOut' }}
            />
				</div>

				{/* Centered "Clarity" Text */}
				<div className="relative z-10 h-full flex items-center justify-between flex-col">
					<div className="flex items-center justify-center h-screen">
						<motion.h1 
						initial={{ opacity: 0, scale: 0.8 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 1, ease: "easeOut" }}
						className="font-source mt-16 sm:mt-20 md:mt-24 lg:mt-28 xl:mt-32 2xl:mt-40 font-source italic leading-tight text-black font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-black font-bold"
					>
						Clarity
					</motion.h1>
					</div>
						{/* Bottom Two-Column Text Section */}
	<div className="w-full">
				<div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-16 xl:gap-20">
						{/* Left Column */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.8 }}
							viewport={{ once: true }}
							className="text-left"
						>
							<p className="text-sm sm:text-base md:text-lg font-sans font-regular text-[#2b2b2b] leading-relaxed">
								We understand that clarity is a necessity. We see young people wrestling with doubt, 
								institutions stuck in old guidance systems and educators searching for better ways to help.
							</p>
						</motion.div>

						{/* Right Column */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							viewport={{ once: true }}
							className="text-left"
						>
							<p className="text-sm sm:text-base md:text-lg font-sans font-regular text-[#2b2b2b] leading-relaxed">
								By bringing together the knowledge of science, the appropriation of empathy and the 
								relevance of cultural intelligence, we have created/compiled an ecosystem that can 
								provide a clear-sighted process to decision making.
							</p>
						</motion.div>
					</div>
				</div>
			</div>
				</div>
			</div>

		
		</section>
	);
};

export default AboutBanner;


